import { Component, Vue } from 'vue-property-decorator';
import { STORE } from '@/core/store/core.store';


@Component({})
export class ContainerUsersMixin extends Vue {

    private validateUsers() : void {    
        if(this.$store.state.HomeworksStore.boardHomeworkHashUsers.length === 0){
            this.initHomeworkUsers();
            return;
        }
        this.loadBoardHomeworkHashUsers();
    }

    private initHomeworkUsers() : void {
        //setTimeout(this.validateUsers, 5000);
    }

    private loadBoardHomeworkHashUsers() : void{
        let promises = [];
        this.$store.state.HomeworksStore.boardHomeworkHashUsers.forEach(homework => {
            promises.push(this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.FILL_HOMEWORK_BOARD_USERS, homework.boardGroupHash));
        });

        Promise.all(promises)
        .finally(() => this.initHomeworkUsers());
    }

    mounted() {
        this.validateUsers();
    }
}